export default __webpack_public_path__ + "static/media/pol1d.ed53d286.svg";